// Media hosted by the api (videos and captions) is stored as a relative path (/media/videos/<file>)
// so that database dumps stay portable between environments. The front resolves it against
// REACT_APP_API_URL. Anything else (a path served by the front nginx such as /videos/intro-1.mp4,
// or an absolute http(s) url) is returned unchanged.
const API_MEDIA_PREFIX = '/media/';

const withoutTrailingSlashes = (value: string): string => {
  let end = value.length;
  while (end > 0 && value[end - 1] === '/') {
    end -= 1;
  }
  return value.slice(0, end);
};

export const resolveMediaUrl = (url?: string): string | undefined => {
  if (!url) {
    return undefined;
  }
  if (!url.startsWith(API_MEDIA_PREFIX)) {
    return url;
  }
  return `${withoutTrailingSlashes(process.env.REACT_APP_API_URL ?? '')}${url}`;
};

/** True for a file hosted by the api, i.e. served from another origin than the front. */
export const isApiMediaUrl = (url?: string): boolean => !!url && url.startsWith(API_MEDIA_PREFIX);

/** File name of a media address (/media/videos/<uuid>.mp4 -> <uuid>.mp4), undefined without address. */
export const mediaFileName = (url?: string): string | undefined => (url ? url.split('/').pop() : undefined);
